import React from 'react';
import { Icon } from 'semantic-ui-react';
import './styles.css';

export default function CarouselTitle(props) {
    const { direction, moveCarousel } = props;
    
    return(
        <button
            id={"painel-carrosseis_carousel-"+direction+"-button"} 
            onClick={() => moveCarousel(direction)}
            className="painel-carrosseis_carousel-button"
        >
            <Icon name={"chevron angle "+direction} />
        </button>
    );
}